import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "py-5 flex justify-between" }
const _hoisted_4 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "border text-xs border-next-dark-gray px-2 rounded-sm mr-2" }
const _hoisted_8 = { class: "relative inline-block p-2 group" }
const _hoisted_9 = { class: "mr-2 border border-next p-1" }
const _hoisted_10 = { class: "mr-1" }
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = { class: "flex justify-end" }
const _hoisted_13 = { class: "rotate-x-180 overflow-x-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Field = _resolveComponent("Field")!
  const _component_MultiselectOption = _resolveComponent("MultiselectOption")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "text-2xl font-bold" }, "Previsionale commerciale", -1)),
        _createVNode(_component_NextButton, {
          component: "router-link",
          to: {name:'CreaBilancioPrevisionale'},
          class: "py-1 px-3"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode(" Nuovo ")
          ])),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Field, {
            "onUpdate:modelValue": [
              _ctx.search,
              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lista.search) = $event))
            ],
            modelValue: _ctx.lista.search,
            field_name: "Cerca",
            placeholder: "Cerca"
          }, null, 8, ["onUpdate:modelValue", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Field, {
            field_name: "Business unit",
            placeholder: "Business unit"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                searchable: true,
                loading: _ctx.buAutocomplete.isLoading,
                "internal-search": false,
                trackBy: "id",
                label: "label",
                onSearchChange: _ctx.buAutocomplete.search,
                modelValue: _ctx.buAutocomplete.selection,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((_ctx.buAutocomplete.selection) = $event)),
                  _ctx.search
                ],
                options: _ctx.buAutocomplete.options,
                multiple: true,
                "close-on-select": false,
                "clear-on-select": false,
                class: "next-vue-multiselect",
                placeholder: "Business Unit",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona"
              }, {
                tag: _withCtx(({option, remove}) => [
                  _createVNode(_component_MultiselectOption, {
                    onRemove: ($event: any) => (remove(option))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(option.label || ' '), 1),
                      _createElementVNode("span", null, _toDisplayString(option.nome), 1)
                    ]),
                    _: 2
                  }, 1032, ["onRemove"])
                ]),
                option: _withCtx(({option, props}) => [
                  _createElementVNode("span", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(option.label), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(option.nome), 1)
                  ])
                ]),
                _: 1
              }, 8, ["loading", "onSearchChange", "modelValue", "options", "onUpdate:modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Field, {
            "onUpdate:modelValue": [
              _ctx.search,
              _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filtro_anno) = $event))
            ],
            modelValue: _ctx.filtro_anno,
            field_name: "Anno",
            type: "number",
            placeholder: "Anno"
          }, null, 8, ["onUpdate:modelValue", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_Paginator, {
          class: "",
          pagination: _ctx.lista.paginate
        }, null, 8, ["pagination"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_NextTable, {
          class: "rotate-x-180 table-auto w-full border-separate border-spacing-3 py-4",
          cols: _ctx.cols,
          "onUpdate:cols": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cols) = $event)),
          rows: _ctx.lista.rows,
          onOrderUpdate: _ctx.lista.updateCols
        }, _createSlots({ _: 2 }, [
          _renderList(_ctx.lista.rows, (c, j) => {
            return {
              name: `td_${j}_3`,
              fn: _withCtx(({context}) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.toEuroCurrency(context.row.previsto)), 1)
              ])
            }
          }),
          _renderList(_ctx.lista.rows, (c, j) => {
            return {
              name: `td_${j}_4`,
              fn: _withCtx(({context}) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.toEuroCurrency(context.row.progresso)), 1)
              ])
            }
          }),
          _renderList(_ctx.lista.rows, (c, j) => {
            return {
              name: `td_${j}_5`,
              fn: _withCtx((context) => [
                _createVNode(_component_router_link, {
                  to: {name:'DettaglioBilancioPrevisionale', params:{id:context.context.row.business_unit_id, bid:context.context.row.id}},
                  class: "text-center inset-0 absolute flex items-center justify-center"
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                  ])),
                  _: 2
                }, 1032, ["to"])
              ])
            }
          })
        ]), 1032, ["cols", "rows", "onOrderUpdate"])
      ]),
      _createVNode(_component_InfiniteLoading, {
        onInfinite: _ctx.lista.fetchNextPage,
        identifier: _ctx.lista.infiniteIdentifier,
        style: {"min-height":"1px"}
      }, {
        complete: _withCtx(() => _cache[7] || (_cache[7] = [
          _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altre attività.", -1)
        ])),
        _: 1
      }, 8, ["onInfinite", "identifier"])
    ])
  ]))
}